import { formatString, stripHtmlTags } from './string';

/**
 * Map array of objects with name and value, to object with name
 * (removing the $wordToReplace from it) as key and url as value.
 */
export const mapArrayToNameValueObject = (fields, wordToReplace: string) => {
  return fields?.reduce(
    (map, field) => ({
      ...map,
      [formatString(field.name, wordToReplace)]: field.value,
    }),
    {}
  );
};

export const isEmptyArray = (array) => {
  if (!Array.isArray(array)) {
    return false;
  }

  if (!array || array?.length < 1) {
    return true;
  }

  return array?.every((item) => !item);
};

export const mergeContentOfArrays = (array: any[], key = 'content', withoutHtml = true) =>
  array?.reduce((map, item) => {
    const content = withoutHtml ? stripHtmlTags(item?.[key]) : item?.[key];

    return `${map} ${content}`;
  }, '');

export const mergeByObjectKey = (key = 'id', array1: any, array2: any) =>
  array1?.map((object1) => {
    const object2 = array2?.find((object2) => object1?.[key] === object2?.[key]);

    if (object2) {
      return { ...object1, ...object2 };
    }

    return object1;
  });

export const concatArrays = (array) => array?.reduce((a, b) => a.concat(b), []);

export const uniqueBy = (array: unknown[], key = 'id') => {
  if (!Array.isArray(array)) {
    return [];
  }

  const unique = new Map();

  array.forEach((item) => {
    unique.set(item[key], item);
  });

  return Array.from(unique.values());
};
